// authTypes.js
export const SIGNOUT_REQUEST = 'SIGNOUT_REQUEST';
